import React, {useContext, useEffect, useState} from "react";
import {GroupContext} from "../GroupContex";
import {IMailParams} from "../../../interfaces/IMailParams";
import {FormChips, FormHelperText, TextField, Snackbar, Mui} from "@leap4/frontend";

const {Alert} = Mui;

const localStoragePhoneNumbersKey = 'PHONE_NUMBERS_GROUPS'

export const MailParamsForm = () => {
    const {group, setGroup} = useContext(GroupContext);
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const groupParams = group.params as IMailParams;
    const optionsList = JSON.parse(localStorage.getItem(localStoragePhoneNumbersKey)) || []

    const handleMailsUpdate = (newMails) => {
        const savedMails = JSON.parse(localStorage.getItem(localStoragePhoneNumbersKey)) || [];
        const allMailsNoDuplicates = Array.from(new Set(savedMails.concat(newMails)));
        localStorage.setItem(localStoragePhoneNumbersKey, JSON.stringify(allMailsNoDuplicates))
    }

    useEffect(() => {
        // to load group to user's localStorage
        handleMailsUpdate(groupParams.recipientsMails)
    }, []);


    const isValidEmail = (email) => {
        if (!email) return true;
        const emailRegex = new RegExp("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$")
        return emailRegex.test(email)
    }
    const updateGroupParams = (e: string[]) => {
        if (isValidEmail(e[e.length - 1])) {
            setGroup({...group, params: {recipientsMails: e}})
            handleMailsUpdate(e)
        } else {
            setIsSnackbarOpen(true)
            // alert("Wrong Email")
            setTimeout(() => setIsSnackbarOpen(false), 3000)
        }
    };

    const handleAlertClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (isSnackbarOpen) return setIsSnackbarOpen(false)
    }


    return <>
        <FormChips
            stackProps={{width: '100%', style: {margin: '20px 0'}}}
            pureCreate={true}
            chips={(group.params as IMailParams).recipientsMails}
            enableCreate={true}
            filterTags={isValidEmail}
            inputName={"Mails List"}
            onUpdateItems={updateGroupParams}
            optionsList={optionsList}
        />
        <Snackbar anchorOrigin={{horizontal:'center', vertical:"top"}} open={isSnackbarOpen} autoHideDuration={3001}  >
            <Alert  severity="error" sx={{width: '100%'}}>
                Invalid Mail Entered </Alert>
        </Snackbar>

    </>
}